export abstract class AppConfig {
  version: string;
  production: boolean;
  adminServer: string;
  reportsServer: string;
  mfaPhonePreValidation: boolean;
  legacyForwardUrl: string;
  /** Browser key for Google Maps. Leave empty to disable the map feature. */
  googleMapsApiKey?: string;
}
